import { render, staticRenderFns } from "./AddStaff.vue?vue&type=template&id=425e24d4&scoped=true"
import script from "./AddStaff.vue?vue&type=script&lang=js"
export * from "./AddStaff.vue?vue&type=script&lang=js"
import style0 from "./AddStaff.vue?vue&type=style&index=0&id=425e24d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e24d4",
  null
  
)

export default component.exports